import React from 'react';

const InviteCode = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4305 6.57031H13.2342V8.36474H14.4305C14.9538 8.36474 15.3277 8.73857 15.3277 9.26195V14.6452C15.3277 15.1686 14.9538 15.5424 14.4305 15.5424H9.0473C8.52394 15.5424 8.1501 15.1686 8.1501 14.6452V13.5985H6.35571V14.6452C6.35571 16.1406 7.55197 17.3369 9.0473 17.3369H14.4305C15.9258 17.3369 17.1221 16.1406 17.1221 14.6452V9.26195C17.1221 7.76659 15.9258 6.57031 14.4305 6.57031Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.81366 3.13036C3.29029 3.13036 2.91646 3.5042 2.91646 4.02757V9.41084C2.91646 9.93422 3.29029 10.3081 3.81366 10.3081H9.19684C9.7202 10.3081 10.094 9.93422 10.094 9.41084V4.02757C10.094 3.5042 9.7202 3.13036 9.19684 3.13036H3.81366ZM9.19684 12.1025H3.81366C2.31833 12.1025 1.12207 10.9062 1.12207 9.41084V4.02757C1.12207 2.53222 2.31833 1.33594 3.81366 1.33594H9.19684C10.6922 1.33594 11.8884 2.53222 11.8884 4.02757V9.41084C11.8884 10.9062 10.6922 12.1025 9.19684 12.1025Z"
        fill="white"
      />
    </svg>
  );
};

export default InviteCode;
